import RootState from 'typings/RootState'
import { Event } from 'Store/common/common.types'
import { ListData, BannerData } from './types'

export const selectBannerListEvent = (state: RootState): Event => state.bannerReducer.bannerListEvent

export const selectBannerList = (state: RootState): ListData => state.bannerReducer.bannerList

export const selectbannerActionEvent = (state: RootState): Event => state.bannerReducer.bannerActionEvent

export const selectBannerDetail = (state: RootState): BannerData | undefined =>
  state.bannerReducer.bannerDetail

export const selectBannerDetailEvent = (state: RootState): Event => state.bannerReducer.bannerDetailEvent
